import { render, staticRenderFns } from "./ScorelessSparring.vue?vue&type=template&id=291654b0&scoped=true"
import script from "./ScorelessSparring.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScorelessSparring.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ScorelessSparring.vue?vue&type=style&index=0&id=291654b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291654b0",
  null
  
)

export default component.exports